export default function ErrorFaceIcon({ className }) {
  return (
    <svg
      className={className}
      width="37"
      height="36"
      viewBox="0 0 37 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_354_463)">
        <mask
          id="mask0_354_463"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="-1"
          width="37"
          height="38"
        >
          <path
            d="M34.8135 25.6071C39.0148 16.5974 35.1168 5.88778 26.1071 1.68647C17.0974 -2.51483 6.38775 1.38317 2.18645 10.3929C-2.01485 19.4026 1.88314 30.1123 10.8929 34.3136C19.9026 38.5149 30.6122 34.6169 34.8135 25.6071Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_354_463)">
          <path
            d="M42.4207 9.2936L9.79358 -5.92065L-5.42068 26.7064L27.2064 41.9207L42.4207 9.2936Z"
            fill="#E6E6E6"
          />
          <path
            d="M-6.0448 19.5109C-8.28107 29.1972 -2.2416 38.8624 7.44474 41.0986C17.1311 43.3349 26.7963 37.2954 29.0325 27.6091C31.2688 17.9228 25.2293 8.25759 15.543 6.02132C5.85664 3.78506 -3.80854 9.82453 -6.0448 19.5109Z"
            fill="#F9F9FC"
          />
          <path
            d="M17.7024 30.0754C18.2793 28.1884 17.2453 26.1996 15.393 25.6333C13.5407 25.067 11.5714 26.1376 10.9945 28.0246C10.4176 29.9115 11.4515 31.9003 13.3038 32.4666C15.1562 33.0329 17.1255 31.9623 17.7024 30.0754Z"
            fill="black"
          />
          <path
            d="M11.4014 22.0646C11.6539 21.2387 11.3565 20.4157 10.737 20.2263C10.1176 20.0369 9.41078 20.5529 9.15828 21.3788C8.90578 22.2047 9.20323 23.0278 9.82265 23.2172C10.4421 23.4065 11.1489 22.8905 11.4014 22.0646Z"
            fill="black"
          />
          <path
            d="M23.3533 24.554C23.6058 23.7281 23.3084 22.9051 22.6889 22.7157C22.0695 22.5263 21.3627 23.0423 21.1102 23.8682C20.8577 24.6941 21.1551 25.5172 21.7746 25.7065C22.394 25.8959 23.1008 25.3799 23.3533 24.554Z"
            fill="black"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_354_463">
          <rect
            width="36"
            height="36"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
